import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { adminGet, adminPost } from '../api/apiClient';

function formatDate(isoString) {
  if (!isoString) return '—';
  return new Intl.DateTimeFormat('pl-PL', { day: 'numeric', month: 'short', year: 'numeric' }).format(new Date(isoString));
}

export function AdminBlogList({ onToast }) {
  const [posts, setPosts]     = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  const load = () => {
    setLoading(true);
    adminGet('/admin/blog-list.php')
      .then((data) => { setPosts(data); setLoading(false); })
      .catch(() => { setError('Nie udało się załadować wpisów.'); setLoading(false); });
  };

  useEffect(load, []);

  const handleDelete = async (post) => {
    if (!window.confirm(`Usunąć wpis „${post.title}"?`)) return;
    try {
      await adminPost('/admin/blog-delete.php', { id: post.id });
      onToast && onToast('Wpis usunięty.');
      load();
    } catch {
      onToast && onToast('Błąd podczas usuwania.', true);
    }
  };

  return (
    <div className="admin-blog-list">
      <div className="admin-blog-list__header">
        <h1 className="admin-blog-list__title">Wpisy</h1>
        <Link to="/admin/blogs/new" className="admin-blog-list__new-btn">
          + Nowy wpis
        </Link>
      </div>

      {loading && <p style={{ color: 'rgba(0,47,93,0.6)', padding: '16px 0' }}>Ładowanie&hellip;</p>}

      {!loading && error && (
        <p className="admin-blog-list__error">{error}</p>
      )}

      {!loading && !error && (
        <div className="admin-blog-list__table-wrap">
          {posts.length === 0 ? (
            <div className="admin-blog-list__empty">
              Brak wpisów. <Link to="/admin/blogs/new">Utwórz pierwszy wpis</Link>.
            </div>
          ) : (
            <table className="admin-blog-list__table">
              <thead>
                <tr>
                  <th>Tytuł</th>
                  <th>Status</th>
                  <th>Opublikowano</th>
                  <th>Zaktualizowano</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {posts.map((post) => (
                  <tr key={post.id}>
                    <td>
                      <strong>{post.title}</strong>
                      <div style={{ fontSize: 11, color: 'rgba(0,47,93,0.55)', marginTop: 2 }}>
                        /{post.slug}
                      </div>
                    </td>
                    <td>
                      <span className={`admin-blog-list__status admin-blog-list__status--${post.status}`}>
                        {post.status === 'published' ? 'Opublikowany' : 'Szkic'}
                      </span>
                    </td>
                    <td>{formatDate(post.published_at)}</td>
                    <td>{formatDate(post.updated_at)}</td>
                    <td>
                      <div className="admin-blog-list__actions">
                        <Link
                          to={`/admin/blogs/${post.id}/edit`}
                          className="admin-blog-list__edit-btn"
                        >
                          Edytuj
                        </Link>
                        <button
                          className="admin-blog-list__delete-btn"
                          onClick={() => handleDelete(post)}
                        >
                          Usuń
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}
